import React from 'react';
import moment from 'moment';
import { Typography, Box } from '@material-ui/core';
import Loader from '../../Loader';
import { useStyles } from '../style';

const CurrentDiscount = ({ title, discount, loading, withBottomPadding }) => {
    const classes = useStyles();
    const today = moment().format('DD.MM.YYYY');

    return (
        <>
            {title && (
                <Typography variant="body2" className={classes.topTitle}>
                    {title}
                </Typography>
            )}
            <Typography className={classes.heading}>Ваша скидка на {today}</Typography>
            {loading && <Loader p={1} size={40} />}
            {!loading && <Typography className={classes.value}>{discount || '-'}%</Typography>}
            {withBottomPadding && <Box mb={3} />}
        </>
    );
};

export default CurrentDiscount;
